import { AxiosResponseHeaders } from 'axios';
import { SwiftCode, BicSwiftCodesResponseDTO } from '../entities';

const bicSwiftCodesResponseDTOToSwiftCodesAdapter = (
  data: BicSwiftCodesResponseDTO,
  headers?: AxiosResponseHeaders,
): SwiftCode => {
  if (!data.body) {
    throw new Error('Error');
  }

  const {
    bicAddress,
    bicAddress2,
    bicAddress3,
    bicBankDept,
    bicBankDescr,
    bicBic,
    bicCentralBank,
    bicCity,
    bicCountry,
    bicCountry2,
    bicExtraAddrInfo,
    bicLocation,
    bicPob,
    bicPrefix,
    bicSubInfor,
    bicSwiftConnFlag,
    bicValueAdded1,
    bicValueAdded2,
    bicZipCodeTown,
  } = data.body;

  return new SwiftCode(
    bicAddress,
    bicAddress2,
    bicAddress3,
    bicBankDept,
    bicBankDescr,
    bicBic,
    bicCentralBank,
    bicCity,
    bicCountry,
    bicCountry2,
    bicExtraAddrInfo,
    bicLocation,
    bicPob,
    bicPrefix,
    bicSubInfor,
    bicSwiftConnFlag,
    bicValueAdded1,
    bicValueAdded2,
    bicZipCodeTown,
  );
};

export { bicSwiftCodesResponseDTOToSwiftCodesAdapter };
